import React from 'react';
import PropTypes from 'prop-types';

import * as utils from 'utils';

import {Marker as MarkerGM} from '@react-google-maps/api';
import iconMarkerActiveUrl from '../../assets/pin-active.svg';
import iconMarkerUrl from '../../assets/pin.svg';
import {InfoWindow} from '..';

export const Marker = ({
  id,
  position,
  tooltip,
  analyticsEvent,
  active,
  setActiveMarker,
}) => {
  const handleClick = () => {
    // Tracking Analytics
    if (analyticsEvent) {
      utils.handleAnalytics('custom', analyticsEvent);
    }

    setActiveMarker(active ? null : id);
  };

  if (!position.lat || !position.lng) return null;

  return (
    <MarkerGM
      key={id}
      position={position}
      clickable={!!tooltip}
      icon={active ? iconMarkerActiveUrl : iconMarkerUrl}
      onClick={handleClick}
    >
      {position && tooltip && (
        <InfoWindow position={position} content={tooltip} visible={active} />
      )}
    </MarkerGM>
  );
};

Marker.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }),
  tooltip: PropTypes.node,
  analyticsEvent: PropTypes.object,
  active: PropTypes.bool,
  setActiveMarker: PropTypes.func,
};

Marker.defaultProps = {
  position: null,
  tooltip: null,
  analyticsEvent: {},
  active: false,
  setActiveMarker: () => null,
};
